import React, { FC } from 'react';

import {
  UserBasicFragment,
  UserGroupBasicFragment,
} from '../../../generated/graphql';
import useIsMobile from '../../../hooks/useIsMobile';
import translate from '../../../i18n/translate';

import AvatarGroup from '../../MUI/AvatarGroup';
import MuiIcon from '../../MUI/MuiIcon';
import MessageNoResult from '../MessageNoResult';

import * as Styled from './styled';

export type Props = {
  groups: UserGroupBasicFragment[];
  users: UserBasicFragment[];
};

/**
 * Show all the groups and people that are assigned to a message
 *
 * @param props        Props passed to the component
 * @param props.groups All the groups assigned to the message
 * @param props.users  All the people assigned to the message
 * @returns            The component itself
 */
const MessageAssignees: FC<Props> = ({ groups, users }) => {
  const isEmpty = groups.length + users.length === 0;
  const isMobile = useIsMobile();

  if (isEmpty) {
    return <MessageNoResult message={translate('ASSIGNMENT__MESSAGE__NONE')} />;
  }

  return (
    <Styled.AssigneesWrapper>
      {groups.length > 0 && (
        <Styled.StyledChip
          aria-label={translate('SETTINGS__GROUPS')}
          color="primary"
          icon={<MuiIcon icon="users" />}
          label={groups.length}
          size={isMobile ? 'small' : 'medium'}
        />
      )}
      <AvatarGroup size={isMobile ? 'small' : 'medium'} users={users} />
    </Styled.AssigneesWrapper>
  );
};

export default MessageAssignees;
